import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CityFilterService {

  filterCities(cityList: any[], topCityList: any[], countryCode: string): any[] {
    const topCityCodes = topCityList.map(city => city.code.toLowerCase());
    const indianCities = cityList.filter(city => city.country.code === countryCode);
    const delhiCities = indianCities.filter(city => city.code.toLowerCase() === 'del');
    const otherIndianCities = indianCities.filter(city => city.code.toLowerCase() !== 'del' && topCityCodes.includes(city.code.toLowerCase()));
    const nonIndianCities = cityList.filter(city => city.country.code !== countryCode);
    return [...delhiCities, ...otherIndianCities, ...nonIndianCities];
  }

  calculateDates(): { nextDayDate: string, tomorrowDate: string, numberOfNights: number } {
    const todayDate = new Date();
    const nextDayDate = new Date(todayDate.getTime() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
    const tomorrowDate = new Date(todayDate.getTime() + 8 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
    const numberOfNights = 1; // Since tomorrow is always the day after the next day
    return { nextDayDate, tomorrowDate, numberOfNights };
  }

  constructor() { }
}
